function validateRequiredInputs(inputIds, requiredMessage) {
  let firstInvalid = null;

  inputIds.forEach((id) => {
    const input = document.getElementById(id);
    if (!input) {
      return;
    }

    input.setCustomValidity("");

    const value = (input.value || "").trim();
    if (value === "") {
      input.setCustomValidity(requiredMessage);
      if (!firstInvalid) {
        firstInvalid = input;
      }
    }
  });

  if (firstInvalid) {
    firstInvalid.reportValidity();
    firstInvalid.focus();
    return false;
  }

  return true;
}

function validateDuplicatedAthletes(nombre, clase, cantidad) {
  let valores = new Map();
  let duplicados = new Set();
  let divDetalle = document.getElementById("detalle_repetidos");

  if (divDetalle) {
    divDetalle.innerHTML = "";
  }

  for (let i = 1; i <= cantidad; i++) {
    let input = null;

    if (clase === "") {
      input = document.getElementById(`${nombre}${i}`);
    } else {
      const selector = `.${clase.trim()}.atleta${i}`;
      input = document.querySelector(selector);
    }

    if (input && input.value.trim() !== "") {
      let valor = input.value.trim().toLowerCase();

      if (valores.has(valor)) {
        duplicados.add(valor);
        valores.get(valor).push(input);
      } else {
        valores.set(valor, [input]);
      }
    }
  }

  document.querySelectorAll(".marcar").forEach((el) => el.classList.remove("marcar"));

  if (duplicados.size > 0) {
    if (divDetalle) {
      let ul = document.createElement("ul");

      duplicados.forEach((valor) => {
        let li = document.createElement("li");
        li.textContent = valor;
        ul.appendChild(li);
      });

      divDetalle.appendChild(ul);
    }

    $("#agregar_atletas").click();

    duplicados.forEach((valor) => {
      valores.get(valor).forEach((input) => input.classList.add("marcar"));
    });

    return false;
  }

  return true;
}

$(document).on("turbolinks:load", function(){
  $(document).off("click.validarNombres", "#torneo_es_drills_true");
  $(document).off("click.validarNombres", "#torneo_es_drills_false");
  $(document).on("click.validarNombres", "#torneo_es_drills_true", function(){
    const text = $("#btn_crear_entr_camp").data("text-entrenamiento");
    $("#atletas_drills").removeClass("ocultar");
    if (text) {
      $("#btn_crear_entr_camp").html(text);
    }
  });
  $(document).on("click.validarNombres", "#torneo_es_drills_false", function(){
    const text = $("#btn_crear_entr_camp").data("text-campeonato");
    $("#atletas_drills").addClass("ocultar");
    if (text) {
      $("#btn_crear_entr_camp").html(text);
    }
  });

  $(document).off("input.validarNombres change.validarNombres", "#torneo_nombre, #torneo_inicio, #torneo_duracion_heat");
  $(document).on("input.validarNombres change.validarNombres", "#torneo_nombre, #torneo_inicio, #torneo_duracion_heat", function(){
    if (this.setCustomValidity) {
      this.setCustomValidity("");
    }
  });

  $(document).off("click.validarNombres", ".auto_fill");
  $(document).on("click.validarNombres", ".auto_fill", function(){
    let cantidad = +$(this).attr("data-cantidad");
    let clase = $(this).attr("data-clase");

    for (let i = 1; i <= cantidad; i++) {
       $("#progr_atleta" + i + "." + clase).val("atleta" + i);
    }
  });

  $(document).off("click.validarNombres", ".validar_crear");
  $(document).on("click.validarNombres", ".validar_crear", function(){
    const requiredMessage = $(this).attr("data-required-message") || "Complete este campo.";
    const nombre = $(this).attr("data-nombre");
    const clase = $(this).attr("data-clase");
    const cantidad = +$(this).attr("data-cantidad");

    if (!validateRequiredInputs(["torneo_nombre", "torneo_inicio"], requiredMessage)) {
      return;
    }

    if (!validateDuplicatedAthletes(nombre, clase, cantidad)) {
      return;
    }

    if (clase === "") {
      $("#btn_ok_atletas").click();
    } else {
      $("#btn_ok_atletas" + clase).click();
    }
  });

  $(document).off("submit.validarNombres", "#form_crear_campeonato");
  $(document).on("submit.validarNombres", "#form_crear_campeonato", function(e){
    const requiredMessage = "Complete este campo.";

    if (!validateRequiredInputs(["torneo_nombre", "torneo_inicio", "torneo_duracion_heat"], requiredMessage)) {
      e.preventDefault();
      return;
    }

    if (!validateDuplicatedAthletes("torneo_atleta", "", 40)) {
      e.preventDefault();
    }
  });
});
